import React, { useContext } from 'react';
import PayoutReport from './PayoutReport/PayoutReport.component';
import PayoutHistory from './PayoutHistory/PayoutHistory.component';
import { payterContext } from '../../hooks/usePayter';
import PayterTerminal from './PayoutTerminal/PayterTerminal.component';

const Payter = () => {
  const payterConsumer = useContext(payterContext);
  const { showTerminal } = payterConsumer;

  return (
    <div className='flex flex-col gap-2'>
      {/* Top row: Revenue summary */}
      <PayoutReport />

      {/* Second row: Financial + Terminal */}
      <div className='flex gap-6 items-start'>
        <div className='flex-2 max-w-3xl'>
          <PayoutHistory />
        </div>
        {showTerminal && (
          <div>
            <PayterTerminal />
          </div>
        )}
      </div>
    </div>
  );
};

export default Payter;
